// removed by extract-text-webpack-plugin
module.exports = {"section":"_1yMq","inner":"CYfa","fullHeight":"_1dth"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/FullWidthSection/FullWidthSection.scss
// module id = rTJB
// module chunks = 0